var _rect, _rect2, _g, _rect3, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 209,
    viewBox: "0 0 209 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 1.29787,
    y: 1.29787,
    width: 206.404,
    height: 206.404,
    rx: 103.202,
    stroke: "white",
    strokeWidth: 1.40426
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3325,
    y: 14.9251,
    width: 179.15,
    height: 179.15,
    rx: 89.575,
    stroke: "white",
    strokeWidth: 1.40426
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_36_1910)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.9565,
    y: 36.9567,
    width: 133.902,
    height: 135.087,
    rx: 66.9509,
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7899,
    y: 32.79,
    width: 142.235,
    height: 143.42,
    rx: 71.1175,
    stroke: "#004638",
    strokeWidth: 8.33333
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_1910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.198 76.6532C95.9567 76.6532 90.0221 82.5174 90.0221 89.7738V105.107C90.0221 112.363 95.9567 118.227 103.198 118.227C110.439 118.227 116.373 112.363 116.373 105.107V89.7738C116.373 82.5174 110.439 76.6532 103.198 76.6532ZM103.198 79.1705C109.151 79.1705 113.91 83.9096 113.91 89.7738V90.1171H107.378C107.341 90.1171 107.303 90.1171 107.266 90.1171C106.608 90.1504 106.095 90.7226 106.128 91.3948C106.16 92.067 106.72 92.5915 107.378 92.5581H113.91V94.9991H107.378C107.341 94.9991 107.303 94.9991 107.266 94.9991C106.608 95.0325 106.095 95.6046 106.128 96.2769C106.16 96.9491 106.72 97.4736 107.378 97.4402H113.91V99.8812H107.378C107.341 99.8812 107.303 99.8812 107.266 99.8812C106.608 99.9146 106.095 100.487 106.128 101.159C106.16 101.831 106.72 102.356 107.378 102.322H113.91V105.107C113.91 110.971 109.151 115.71 103.198 115.71C97.2444 115.71 92.4855 110.971 92.4855 105.107V102.322H99.0174C99.4466 102.327 99.8478 102.098 100.067 101.717C100.282 101.335 100.282 100.868 100.067 100.487C99.8478 100.105 99.4466 99.8765 99.0174 99.8812H92.4855V97.4402H99.0174C99.4466 97.445 99.8478 97.2161 100.067 96.8347C100.282 96.4533 100.282 95.986 100.067 95.6046C99.8478 95.2232 99.4466 94.9944 99.0174 94.9991H92.4855V92.5581H99.0174C99.4466 92.5629 99.8478 92.334 100.067 91.9526C100.282 91.5712 100.282 91.104 100.067 90.7226C99.8478 90.3411 99.4466 90.1123 99.0174 90.1171H92.4855V89.7738C92.4855 83.9096 97.2444 79.1705 103.198 79.1705ZM85.0579 97.5927C84.568 97.6976 84.2227 98.1506 84.2367 98.6607V104.763C84.2367 114.165 90.8619 122.056 99.5772 123.796V131.615H91.8137C89.5415 131.615 87.6706 133.531 87.6706 135.848V137.641H118.576V135.848C118.576 133.531 116.705 131.615 114.432 131.615H106.818V123.796C115.534 122.056 122.159 114.165 122.159 104.763V98.6607C122.159 98.0695 121.692 97.5927 121.114 97.5927C120.535 97.5927 120.069 98.0695 120.069 98.6607V104.763C120.069 114.284 112.515 122.003 103.198 122.003C93.8805 122.003 86.3269 114.284 86.3269 104.763V98.6607C86.3316 98.3556 86.2056 98.0647 85.9863 97.8597C85.7624 97.6547 85.4685 97.5546 85.1699 97.5927C85.1325 97.5927 85.0952 97.5927 85.0579 97.5927ZM102.041 124.063C102.423 124.087 102.81 124.139 103.198 124.139C103.585 124.139 103.972 124.087 104.355 124.063V131.577H102.041V124.063ZM91.8137 134.056H100.51C100.608 134.08 100.706 134.094 100.809 134.094H105.587C105.675 134.089 105.764 134.08 105.848 134.056H114.432C115.198 134.056 115.706 134.571 115.963 135.238H90.2834C90.54 134.571 91.0438 134.056 91.8137 134.056Z",
    fill: "#084A49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_36_1910",
    x: 8.62329,
    y: 14.6233,
    width: 190.568,
    height: 179.753,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 20,
    dy: 14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_36_1910"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -20,
    dy: -14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_36_1910",
    result: "effect2_innerShadow_36_1910"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_1910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.7197,
    height: 61.026,
    fill: "white",
    transform: "translate(74.2832 76.6532)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartIcon);
export default __webpack_public_path__ + "static/media/start-icon.7724cd8883dcfe19a2318185aeab69e0.svg";
export { ForwardRef as ReactComponent };